<script lang="ts" module>
  const LABELABLE_ELEMENTS =
    "input, textarea, select, button, meter, output, progress"
</script>

<script lang="ts">
  import { getUiclContext } from "#lib/internal/helpers/uiclContext"
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"
  import { onMount, type Snippet } from "svelte"
  import { labelVariants } from "./variants"

  type Props = BaseProps<"label"> & {
    size?: "medium" | "large"
    disabled?: boolean | undefined
    children?: Snippet
  }

  let {
    class: className,
    for: htmlFor,
    disabled,
    size = "medium",
    children,
    ...restProps
  }: Props = $props()

  let ref: HTMLLabelElement
  let hasLabelableElement = $state(false)

  function handleMouseDown(event: MouseEvent) {
    if (!event.defaultPrevented && event.detail > 1) {
      event.preventDefault()
    }
  }

  function handleClick() {
    if (!htmlFor || disabled) return

    let target = document.getElementById(htmlFor)
    if (!target) return

    const { labelDelegate } = target.dataset
    if (labelDelegate) {
      const delegate = document.getElementById(labelDelegate)
      if (delegate) {
        target = delegate
      }
    }

    target.focus()
  }

  onMount(() => {
    hasLabelableElement = !!ref.querySelector(LABELABLE_ELEMENTS)
  })

  const v2 = !!getUiclContext()?.v2
</script>

<label
  bind:this={ref}
  onmousedown={handleMouseDown}
  onclick={handleClick}
  data-size={size}
  aria-disabled={disabled}
  class={cn(
    {
      "cursor-pointer": htmlFor || hasLabelableElement,
    },
    labelVariants({ size, v2 }),
    className
  )}
  for={htmlFor}
  {...restProps}
>
  {@render children?.()}
</label>
